// ----- import components

import Header from "../blocks/modules/header/header"
import ServicesSlider from "../blocks/components/services-slider/services-slider"
import StepsSlider from "../blocks/components/steps-slider/steps-slider"
import Faq from "../blocks/components/faq/faq"
import FSlider from "../blocks/components/f-slider/f-slider"
import Input from "../blocks/components/input/input"
import FPlate from "../blocks/components/f-plate/f-plate"
import About from "../blocks/modules/about/about"
import ArticleNav from "../blocks/components/article-nav/article-nav"
import YtVideo from "../blocks/components/yt-video/yt-video"
import NewsSlider from "../blocks/components/news-slider/news-slider"
import Timer from "../blocks/components/timer/timer"
import PSlider from "../blocks/components/p-slider/p-slider"
import Accordion from "../blocks/components/accordion/accordion"
import Tabs from "./global/tabs"
import Rating from "../blocks/components/rating/rating"
import SCard from "./global/scard"

// ----- import functions

import { scrollToId } from "./global/scrollToId"
import { copyShareLink } from "../blocks/components/share/share"
// import { startLottieAnimation } from "./global/lottieAnimation"

// ----- env

// import { BASE_URL } from '../../env-config'

// ----- components instances

let header = null
let servicesSlider = []
let stepsSlider = []
let faq = []
let fSlider = []
let inputs = []
let fplates = []
let ytVideo = []
let newsSlider = []
let timer = []
let accordion = []
let pslider = []
let tabs = []
let rating = []
let scard = []
let about = null
let articleNav = null

// ----- flags

let isMobile = false

function checkMobile () {
  isMobile = /iPad|iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/.test(navigator.userAgent)

  if(!isMobile && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel|iPad/.test(navigator.platform)) {
    isMobile = true
  }

  if (!isMobile && window.innerWidth < 1025) {
    isMobile = true
  }

  if (isMobile) {
    document.body.classList.add('mobile')
  }
}

// ----- inject youtube api
const ytVideoItems = document.querySelectorAll(".js-yt-video");
if (ytVideoItems.length) {
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  tag.setAttribute('data-swup-ignore-script', true)
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

// ----- events

document.addEventListener('DOMContentLoaded', () => {
  init()
})

window.onYouTubeIframeAPIReady = () => {
  const ytItems = document.querySelectorAll(".js-yt-video");
  if ( ytItems.length ) {
    ytItems.forEach ( (el, i) => {
      ytVideo[i] = new YtVideo(el)
    })
  }
}

// ----- init components

function init () {

  checkMobile()
  scrollToId()
  copyShareLink()

  $(document).on('click', '[data-modal-open]', e => {
    e.preventDefault()
    const target = e.target.closest('[data-modal-open]')
    const id = target.getAttribute('data-modal-id')
    const modal = document.querySelector(id)

    if (modal) {
      modal.classList.add('active')
      document.body.classList.add('block-scroll')
    }
  })
  
  $(document).on('click', '[data-modal-close]', e => {
    e.preventDefault()
    const target = e.target
    const modal = target.closest('.js-modal')

    if (modal) {
      modal.classList.remove('active')
      document.body.classList.remove('block-scroll')
    }
  })

  const headerElement = document.querySelector('.js-header')
  if (headerElement) {
    header = new Header(headerElement)
    header.init()
  }
  
  const servicesSliderItems = document.querySelectorAll('.js-services-slider')
  if (servicesSliderItems.length) {
    servicesSliderItems.forEach((el, i) => {
      servicesSlider[i] = new ServicesSlider(el)
      servicesSlider[i].init()
    })
  }
  
  const stepsSliderItems = document.querySelectorAll('.js-steps-slider')
  if (stepsSliderItems.length) {
    stepsSliderItems.forEach((el, i) => {
      stepsSlider[i] = new StepsSlider(el)
      stepsSlider[i].init()
    })
  }
  
  const fSliderItems = document.querySelectorAll('.js-f-slider')
  if (fSliderItems.length) {
    fSliderItems.forEach((el, i) => {
      fSlider[i] = new FSlider(el)
      fSlider[i].init()
    })
  }
  
  const faqItems = document.querySelectorAll('.js-faq')
  if (faqItems.length) {
    faqItems.forEach((el, i) => {
      faq[i] = new Faq(el)
      faq[i].init()
    })
  }
  
  const accordionItems = document.querySelectorAll('.js-accordion')
  if (accordionItems.length) {
    accordionItems.forEach((el, i) => {
      accordion[i] = new Accordion(el)
      accordion[i].init()
    })
  }
  
  const inputItems = document.querySelectorAll('.js-input')
  if (inputItems.length) {
    inputItems.forEach((el, i) => {
      inputs[i] = new Input(el)
      inputs[i].init()
    })
  }
  const fplateItems = document.querySelectorAll('.js-f-plate')
  if (fplateItems.length) {
    fplateItems.forEach((el, i) => {
      fplates[i] = new FPlate(el)
      fplates[i].init()
    })
  }
  
  const aboutItem = document.querySelector('.js-about-slider')
  if (aboutItem) {
    about = new About(aboutItem)
    about.init()
  }

  let articleNavEl = document.querySelector('.js-article-nav')

  if (articleNavEl) {
    articleNav = new ArticleNav(articleNavEl)
    articleNav.init()
  }
  
  let newsSliderItems = document.querySelectorAll('.js-news-slider')

  if (newsSliderItems.length) {
    newsSliderItems.forEach((el, i) => {
      newsSlider[i] = new NewsSlider(el)
      newsSlider[i].init()
    })
  }
  
  let timerItems = document.querySelectorAll('.js-timer')

  if (timerItems.length) {
    timerItems.forEach((el, i) => {
      timer[i] = new Timer(el)
      timer[i].init()
    })
  }

  let psliderItems = document.querySelectorAll('.js-p-slider')

  if (psliderItems.length) {
    psliderItems.forEach((el, i) => {
      pslider[i] = new PSlider(el)
      pslider[i].init()
    })
  }


  let tabsItems = document.querySelectorAll('.js-tabs')

  if (tabsItems.length) {
    tabsItems.forEach((el, i) => {
      tabs[i] = new Tabs(el)
      tabs[i].init()
    })
  }
  
  let ratingItems = document.querySelectorAll('.js-rating')

  if (ratingItems.length) {
    ratingItems.forEach((el, i) => {
      rating[i] = new Rating(el)
      rating[i].init()
    })
  }
  
  let scardItems = document.querySelectorAll('.js-s-card')

  if (scardItems.length) {
    scardItems.forEach((el, i) => {
      scard[i] = new SCard(el)
      scard[i].init()
    })
  }

  // startLottieAnimation()

}
